(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vikis-recipe-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vikis-recipe-library')) {
    customElements.define('vikis-recipe-library', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.pet = 'dog';
        this.food = 'raw_top';
        this.recipes = Array.from(this.querySelectorAll('.vrl__standard [data-recipe]'));
        this.petButtons = Array.from(this.querySelectorAll('[data-pet]'));
        this.foodButtons = Array.from(this.querySelectorAll('[data-food]'));
        this.querySelector('.vrl__controls').hidden = false;
        this.petButtons.forEach(button => button.addEventListener('click', () => { this.pet = button.dataset.pet; this.update(true); }));
        this.foodButtons.forEach(button => button.addEventListener('click', () => { this.food = button.dataset.food; this.update(true); }));
        this.querySelectorAll('[data-recipe]').forEach(recipe => recipe.addEventListener('toggle', () => {
          if (!recipe.open) return;
          const group = recipe.parentElement;
          group.querySelectorAll(':scope > [data-recipe]').forEach(other => { if (other !== recipe) other.open = false; });
        }));
        this.update(false);
      }
      update(announce) {
        this.querySelectorAll('[data-photo-species]').forEach(group => { group.hidden = group.dataset.photoSpecies !== this.pet; });
        const available = new Set(this.recipes.filter(recipe => recipe.dataset.species === this.pet).map(recipe => recipe.dataset.category));
        if (!available.has(this.food)) this.food = this.foodButtons.find(button => available.has(button.dataset.food))?.dataset.food;
        this.petButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pet === this.pet)));
        this.foodButtons.forEach(button => {
          button.hidden = !available.has(button.dataset.food);
          button.setAttribute('aria-pressed', String(button.dataset.food === this.food));
        });
        let count = 0;
        this.recipes.forEach(recipe => {
          recipe.hidden = recipe.dataset.species !== this.pet || recipe.dataset.category !== this.food;
          recipe.open = !recipe.hidden && count++ === 0;
        });
        if (announce) {
          const status = this.querySelector('[data-recipe-status]');
          const foodLabel = this.foodButtons.find(button => button.dataset.food === this.food).textContent.trim();
          status.textContent = status.dataset.statusTemplate.replace('[count]', String(count)).replace('[category]', foodLabel);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
